import { c as _c } from "react/compiler-runtime";
import { WithCommonProps } from '@types';
export type IAnalyticsRefProps = WithCommonProps<{
  children: React.ReactNode;
  name: string;
}>;
export const AnalyticsRef: React.FC<IAnalyticsRefProps> = t0 => {
  const $ = _c(8);
  let children;
  let name;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      name,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = name;
    $[3] = props;
  } else {
    children = $[1];
    name = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== name || $[6] !== props) {
    t1 = <div data-tag-ref={name} {...props}>{children}</div>;
    $[4] = children;
    $[5] = name;
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};